import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  AB_DASHBOARD_URL,
  AB_ACCESS_DENIED_REDIRECT_INTERVAL
} from '../../constants';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss/layout';

@Component({
  selector: 'ab-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit {
  @Input() rendering: ComponentRendering;
  @Input() stopTimer = false;
  constructor(private router: Router) {}

  ngOnInit() {
    if (!this.stopTimer) {
      setTimeout(() => {
        this.router.navigate([AB_DASHBOARD_URL]);
      }, AB_ACCESS_DENIED_REDIRECT_INTERVAL);
    }
  }
}
